export function normalizeMarkdownTable(markdown: string): string {
    if (!markdown) return markdown;

    const lines = markdown.split("\n");
    const headerIndex = lines.findIndex((line) => line.includes("|"));
    if (headerIndex === -1 || headerIndex + 1 >= lines.length) return markdown;

    const headerLine = lines[headerIndex].trim();
    const separatorLine = lines[headerIndex + 1].trim();
    const countPipes = (line: string) => line.split("").filter((char) => char === "|").length;

    if (countPipes(headerLine) !== countPipes(separatorLine)) {
        lines[headerIndex + 1] = "|---|";
    }

    return lines.join("\n");
}
